<template>
  <div>
    <div class="artist-portrait" :class="{loaded: loaded}">
      <img :src="artistPortraitUrl" />
    </div>
    <div class="tag-panel">
      <gallery-tag v-for="gallery in galleries" :key="gallery.gallery_id" :galleryId="gallery.gallery_id" />
      <div class="tag region" v-on:click.stop="changeRegion(artist.region)">{{ artist.region }}</div>
    </div>
    <div class="pf-intro" v-html="details.overview"></div>
    <div v-if="artist.video" class="pf-main">
      <video-widget :url="artist.video" />
    </div>
    <div class="pf-main" v-html="details.text"></div>
    <div class="pf-main">
      <h3>Client list</h3>
      {{ details.client_list }}
    </div>
    <div class="button-group-padded">
      <div class="bgp-title">{{ $nippets.portfolio.wantToDiscuss }}</div>
      <email-and-call :artist="artist" />
    </div>
  </div>
</template>

<script>
import VideoWidget from '@/components/widgets/VideoWidget.vue'
import GalleryTag from '@/components/buttons/GalleryTag.vue'
import EmailAndCall from '@/components/panels/EmailAndCall.vue'

import apix from '@/api.js'
const memstore = {
  details: {}
}
export default {
  components: {
    VideoWidget,
    GalleryTag,
    EmailAndCall
  },
  props: {
    artist: Object,
    animation: Boolean
  },
  created () {
    this.loadData ()
  },
  data () {
    return {
      details: {},
      galleries: [],
      loaded: false,
      artistPortraitUrl: ''
    }
  },
  methods: {
    loadData: async function () {
      if(!this.artist) return
      if(!this.artist.artist_id) return
      this.loaded = false
      this.artistPortraitUrl = this.$k.getArtistPortraitUrl(this.artist.portfolio_url)
      let res = memstore.details[this.artist.artist_id]
      if(!res) {
        if(!this.artist.illustrator){
          res = await apix.post('collections/animators/details', { artist_id: Number(this.artist.artist_id), lang: this.$store.state.lang })
        }
        else {
          res = await apix.post('collections/artists/details', { artist_id: Number(this.artist.artist_id), lang: this.$store.state.lang })
        }
        res = res.data
        memstore.details[this.artist.artist_id] = res
      }
      await this.$store.dispatch('fetchGalleries')
      this.galleries = this.$store.getters.artistGalleries(this.artist).filter(el => el.animation === this.animation)
      this.details = res
      this.$emit('load', this.details)
      this.loaded = true
    },
    changeRegion: function (region) {
      this.$emit('changeRegion', region)
    }
  },
  watch: {
    artist () {
      this.loadData()
    }
  }
}
</script>
<style>
.pf-main h3{
  font-weight:400;
  text-transform:uppercase;
  margin:20px 0 4px 0;
  font-size:17px;
  color:#101820;
}


</style>

<style scoped>
.pf-intro{
  line-height:21px;
}
.tag-panel{
  margin:20px 0;
}
.pf-main {
  font-weight:300;
  line-height:21px;
  margin: 30px 0;
}
.artist-portrait{
  border-radius:50%;
  width:70%;
  height:70%;
  overflow: hidden;
  opacity:0;
  transition: all 0.2s ease;
}

.artist-portrait.loaded{
  opacity:1;
}

.artist-portrait img{
  width:100%;
  height:100%;
  display:block;
}


.button-group-padded{
  margin:20px 0;
}

.bgp-title{
  font-weight:500;
  margin-bottom:10px;
}
</style>